var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("license-form-dialog", {
        ref: "licenseDialog",
        on: {
          error: _vm.onCreateLicenseError,
          created: _vm.onCreateLicenseSuccess
        }
      }),
      _c(
        "md-layout",
        { attrs: { "md-flex": "90" } },
        [
          _c(
            "md-input-container",
            { class: { "md-input-invalid": _vm.showRequiredError } },
            [
              _c("label", { attrs: { for: "license" } }, [_vm._v("License")]),
              _c(
                "md-select",
                {
                  attrs: {
                    id: "license",
                    name: "license",
                    multiple: _vm.multiple
                  },
                  on: { selected: _vm.onLicenseSelected },
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                _vm._l(_vm.filteredLicenses, function(license) {
                  return _c(
                    "md-option",
                    {
                      key: license._id,
                      class: {
                        expired: _vm.isLicenseExpired(license),
                        draft: _vm.isLicenseDraft(license)
                      },
                      attrs: { value: license._id }
                    },
                    [_vm._v(_vm._s(license.name))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showRequiredError,
                  expression: "showRequiredError"
                }
              ],
              staticClass: "md-error"
            },
            [_vm._v("This field is required")]
          )
        ],
        1
      ),
      _c(
        "md-layout",
        {
          staticClass: "add-license-button",
          attrs: { "md-flex": "10", "md-align": "center" }
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button md-raised md-dense md-mini",
              on: { click: _vm.openLicenseFormDialog }
            },
            [_c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } })],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasExpiredLicenses,
              expression: "hasExpiredLicenses"
            }
          ],
          staticClass: "expired"
        },
        [_vm._v("One or more selected licenses are expired")]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasDraftLicenses,
              expression: "hasDraftLicenses"
            }
          ],
          staticClass: "draft"
        },
        [_vm._v("One or more selected licenses are draft")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-698ef3b8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698ef3b8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/license/LicenseSelector.vue
// module id = 936
// module chunks = 0